// src/hooks/useBackendConfig.js

import { useState, useEffect } from 'react';
import { authFetch } from '../utils/authFetch';

export function useBackendConfig() {
  const [config, setConfig] = useState({ samplingInterval: 1000 });

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/config`);
        if (!res.ok) throw new Error("Failed to fetch backend config");
        const json = await res.json();

        if (json.samplingInterval) {
          setConfig({ samplingInterval: json.samplingInterval * 1000 }); // convert to ms
        } else {
          console.warn("Backend config missing samplingInterval — using default.");
        }
      } catch (err) {
        console.error("Failed to fetch backend config:", err);
      }
    };

    loadConfig();
  }, []);

    return config;
}
